import {useField, useFormikContext} from 'formik'
import {FC, useEffect} from 'react'

type HiddenFieldProps = {
  name: string
  value: any
}

const HiddenField: FC<HiddenFieldProps> = ({name, value}) => {
  useFormikContext()
  const [, , {setValue}] = useField(name)

  useEffect(() => {
    setValue(value)
    // actions are different each render, we can't put them into dependecies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])

  return <input hidden name={name} />
}

export default HiddenField
